import React from 'react';
import FaqContent from './FaqContent';
import FaqTrigger from './FaqTrigger';
import styles from './landingFaq.module.css';
import type { FaqItemData } from './FaqAccordion';

interface FaqItemProps {
  item: FaqItemData;
  isOpen: boolean;
  onToggle: () => void;
}

const FaqItem: React.FC<FaqItemProps> = ({ item, isOpen, onToggle }) => (
  <article className={styles.faqItem}>
    <FaqTrigger question={item.question} isOpen={isOpen} onToggle={onToggle} />
    <FaqContent answer={item.answer} isOpen={isOpen} />
  </article>
);

export default FaqItem;
